import React, { useState } from 'react'
import { useTenantFormContext } from '../tenant-form-context'
import { useStyles } from './style'
import { Grid, Typography, Tooltip } from '@mui/material'
import { ActionButton } from '@emerald-works-nova/components'
import { FeatureFormContext } from '../features-tab/feature-form-context'
import classNames from 'classnames'
import ContentHubSettings from './content-hub'
import SkillBitesSettings from './skill-bites'
import MSASettings from './msa'
import ContentHubConfirmationModal from '../components/content-hub-confirmation'
import MobileAppSettings from './mobile-app'
import MSBSettings from './msb'
import SkillsPracticeSettings from './skills-practice'
import { CONSTANTS } from '../../../util/constants'
import AccelerateSettings from './accelerate'

const ProductsTab = () => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const { isEdit, handlePreviousClick, handleCreateTenant, mainClasses, tenant, form } = useTenantFormContext()
  const { watch } = form
  const [features, baseTemplate] = watch(['features', 'baseTemplate'])
  const hasContentHub = features?.contentHub
  const hasSkillBites = features?.skillBite?.enabled
  const isClub = (tenant?.pk === CONSTANTS.DEFAULT_CLUB_PK)

  const hasMSA = features?.assessment?.enabled ?? features?.msa

  const allFeaturesDisabled = !hasContentHub && !hasSkillBites && !hasMSA
  const isDisabled = (allFeaturesDisabled || (hasContentHub && !baseTemplate))

  const renderTooltipText = () => {
    if (allFeaturesDisabled) {
      return 'Please, select at least one product to create a Toolkit'
    }

    if (hasContentHub && !baseTemplate) {
      return 'Please, select a Template to create a Toolkit with Content Hub'
    }

    return null
  }

  return (
    <FeatureFormContext.Provider value={{ tenant }}>
      <Grid className={classes.root}>
        <Grid container alignItems='center' className={classNames(mainClasses.ctnTitle, classes.ctnTitle)}>
          <Grid item xs={9}>
            <Typography variant='h6' data-test='products-tab-title'>Products</Typography>
            <Typography variant='body2' data-test='products-tab-description'>Define products will be available on Toolkit</Typography>
          </Grid>
          <Grid container item justifyContent='flex-end' xs={3}>
            {!isEdit && (
              <>
                <ActionButton
                  variant='primary'
                  dataTest='create-tenant-previous-button'
                  onClick={handlePreviousClick}
                  className={mainClasses.navBtn}
                >Previous
                </ActionButton>

                <Tooltip title={renderTooltipText()} arrow>
                  <span>
                    <ActionButton
                      variant='primary'
                      dataTest='create-tenant-create-button'
                      onClick={() => setOpen(true)}
                      className={mainClasses.navBtn}
                      disabled={isDisabled}
                    >
                      Create
                    </ActionButton>
                  </span>
                </Tooltip>
              </>
            )}
          </Grid>
        </Grid>
        <Grid data-test='products-tab-products-list'>
          <Grid item xs={12} data-test='products-tab-accelerate-settings'>
            <AccelerateSettings />
          </Grid>
          <Grid item xs={12} data-test='products-tab-content-hub-settings'>
            <ContentHubSettings />
          </Grid>
          <Grid item xs={12} data-test='products-tab-skill-bites-settings'>
            <SkillBitesSettings />
          </Grid>
          {!isClub && (
            <Grid item xs={12} data-test='products-tab-msb-settings'>
              <MSBSettings />
            </Grid>
          )}
          <Grid item xs={12} data-test='products-tab-msa-settings'>
            <MSASettings />
          </Grid>
          {!isClub && (
            <Grid item xs={12} data-test='products-tab-skills-practice-settings'>
              <SkillsPracticeSettings />
            </Grid>
          )}
          <Grid item xs={12} data-test='products-tab-mobile-app-settings'>
            <MobileAppSettings />
          </Grid>
        </Grid>
      </Grid>
      <ContentHubConfirmationModal open={open} onClose={() => setOpen(false)} handleConfirmation={handleCreateTenant} />
    </FeatureFormContext.Provider>
  )
}

export default ProductsTab
